import { CommonLabel, FlexBox, useBreakpoint, useIsMobile, useToasts, CommonLabelText, BrgButton, ButtonVariant } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { useModal } from "core/modules/modal.module";
import { useController, useFormContext } from "react-hook-form";
import urlApi from "shared/actions/urlApi";
import { useCallback, useMemo } from "react";
import { LayoutConst } from "core";
import { ProjectAddButton } from "../../ProjectAddButton";
import { ReproductionList } from "../../components/Cards/ReproductionList";
import { ColumnLabelGroup, ProjectEditPageGridRow, ProjectEditPageGridRowBase } from "../../styles";
import { useBookEditor } from "_deziiign/books/pages/BookEdit/providers/bookEditorProvider";
import { FlorinIcon } from "shared/icons/FlorinIcon/FlorinIcon";
import styled from "styled-components";
import { SettingsLabel } from "../../components/PresentatitonBlock/styles";
import { UpsertBookData } from "shared/actions/Book/UpsertBookData";
import { useDispatch, useSelector } from "react-redux";
import { getAvailableTariffs, selectorOrder } from "shared/features/QueuePaymenrt/slices/OrderSlice";
import { EntityPaymentTypes } from "shared/features/QueuePaymenrt/constants/payment";
import { useTariffs } from "shared/features/QueuePaymenrt/components/Queue/helpers/queueHooks";

export const QueuePriceText = styled.div`
    display: flex;
    align-items: center;
    font-family: Inter;
    font-size: 26px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.02em;
    gap: 4px;
    color: ${({ theme }) => theme.app.text};
`

const BookReproductionsField = () => {
    const {field: { value, onChange }} = useController({name: 'includedReproductionsIds'});
    const { t } = useTranslation();
    const modal = useModal();
    const isMobile = useIsMobile();
    const isProjectEditPage = !!useRouteMatch('/edit')
    const isBookEdit = !!useRouteMatch('/books/edit')
    const toasts = useToasts();
    const { activeTariff } = useSelector(selectorOrder)
    const { changePrice } = useTariffs({})

    const { 
        bookId, 
        activeCardIds, 
        setActiveCardIds, 
        setIsCardsUpdateIsLoading,
        updateAvailableTariffs
    } = useBookEditor();

    const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    const is1440 = useMemo(() => (isMac13 || smHeight), [isMac13, smHeight])

    const onUpdateReproductionGoods = async (data: string[], isDelete?: boolean) => {
        try {
            urlApi()
            .UpdateReproductions(bookId, data)
            .then(({ status }) => {
              if (status === 200) {
                toasts.info(
                    isDelete ?
                        t('project_edit.modal.reproduction.delete_msg') :
                        t('project_edit.modal.reproduction.update_msg')
                );
                onChange(data)
                updateAvailableTariffs()
              }
            })
        }
        catch (err: unknown) {
            toasts.error('Что-то пошло не так')
        }
    }

    const openModal = () => {
        modal.show('project-reproductions', {
            projectId: bookId,
            cardIds: value,
            multiple: true,
            onSubmit: (data: string[]) => {
                modal.hide();
                onUpdateReproductionGoods(data)
            }
        })
    }

    return (
        <ProjectEditPageGridRowBase className={'mobile-block-5'} direction="column" directionMobile="column" gy={16}>
            <ColumnLabelGroup >
                <SettingsLabel>
                    {t('book_edit.collection_cards')}
                </SettingsLabel>
                <CommonLabelText>
                    {t('project_edit.add_reproductions_info')}
                </CommonLabelText>
            </ColumnLabelGroup>
            {!value?.length && (
                <ColumnLabelGroup >
                    <CommonLabelText>
                        {t('project_edit.add_reproductions_many')}
                    </CommonLabelText>
                    <BrgButton variant={ButtonVariant.Hollow} onClick={openModal} fullWidth>
                        {t('project_edit.select_reproductions')}
                    </BrgButton>
                </ColumnLabelGroup>
            )}
            <ReproductionList ignoreUserId cardsIds={value} onDelete={onUpdateReproductionGoods} onEdit={openModal} />
            <ColumnLabelGroup >
                <CommonLabelText>
                    {t('tariffs.book_price')}
                </CommonLabelText>
                <QueuePriceText>
                    {activeTariff?.userPrice || '0'} <FlorinIcon size={20 / 16} mobileSize={20 / 16} margin="0" />
                </QueuePriceText>
            </ColumnLabelGroup>
        </ProjectEditPageGridRowBase>

    )
};

export default BookReproductionsField;import { CommonLabel, FlexBox, useBreakpoint, useIsMobile, useToasts, CommonLabelText, BrgButton, ButtonVariant } from "@brg/ui";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";
import { useModal } from "core/modules/modal.module";
import { useController, useFormContext } from "react-hook-form";
import urlApi from "shared/actions/urlApi";
import { useCallback, useMemo } from "react";
import { LayoutConst } from "core";
import { ProjectAddButton } from "../../ProjectAddButton";
import { ReproductionList } from "../../components/Cards/ReproductionList";
import { ColumnLabelGroup, ProjectEditPageGridRow, ProjectEditPageGridRowBase } from "../../styles";
import { useBookEditor } from "_deziiign/books/pages/BookEdit/providers/bookEditorProvider";
import { FlorinIcon } from "shared/icons/FlorinIcon/FlorinIcon";
import styled from "styled-components";
import { SettingsLabel } from "../../components/PresentatitonBlock/styles";
import { UpsertBookData } from "shared/actions/Book/UpsertBookData";
import { useDispatch, useSelector } from "react-redux";
import { getAvailableTariffs, selectorOrder } from "shared/features/QueuePaymenrt/slices/OrderSlice";
import { EntityPaymentTypes } from "shared/features/QueuePaymenrt/constants/payment";
import { useTariffs } from "shared/features/QueuePaymenrt/components/Queue/helpers/queueHooks";

export const QueuePriceText = styled.div`
    display: flex;
    align-items: center;
    font-family: Inter;
    font-size: 26px;
    font-weight: 600;
    line-height: 32px;
    letter-spacing: -0.02em;
    gap: 4px;
    color: ${({ theme }) => theme.app.text};
`

const BookReproductionsField = () => {
    const {field: { value, onChange }} = useController({name: 'includedReproductionsIds'});
    const { t } = useTranslation();
    const modal = useModal();
    const isMobile = useIsMobile();
    const isProjectEditPage = !!useRouteMatch('/edit')
    const isBookEdit = !!useRouteMatch('/books/edit')
    const toasts = useToasts();
    const { activeTariff } = useSelector(selectorOrder)
    const { changePrice } = useTariffs({})

    const { 
        bookId, 
        activeCardIds, 
        setActiveCardIds, 
        setIsCardsUpdateIsLoading,
        updateAvailableTariffs
    } = useBookEditor();

    const isMac13 = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    const is1440 = useMemo(() => (isMac13 || smHeight), [isMac13, smHeight])

    const onUpdateReproductionGoods = async (data: string[], isDelete?: boolean) => {
        try {
            urlApi()
            .UpdateReproductions(bookId, data)
            .then(({ status }) => {
              if (status === 200) {
                toasts.info(
                    isDelete ?
                        t('project_edit.modal.reproduction.delete_msg') :
                        t('project_edit.modal.reproduction.update_msg')
                );
                onChange(data)
                updateAvailableTariffs()
              }
            })
        }
        catch (err: unknown) {
            toasts.error('Что-то пошло не так')
        }
    }

    const openModal = () => {
        modal.show('project-reproductions', {
            projectId: bookId,
            cardIds: value,
            multiple: true,
            onSubmit: (data: string[]) => {
                modal.hide();
                onUpdateReproductionGoods(data)
            }
        })
    }

    return (
        <ProjectEditPageGridRowBase className={'mobile-block-5'} direction="column" directionMobile="column" gy={16}>
            <ColumnLabelGroup >
                <SettingsLabel>
                    {t('book_edit.collection_cards')}
                </SettingsLabel>
                <CommonLabelText>
                    {t('project_edit.add_reproductions_info')}
                </CommonLabelText>
            </ColumnLabelGroup>
            {!value?.length && (
                <ColumnLabelGroup >
                    <CommonLabelText>
                        {t('project_edit.add_reproductions_many')}
                    </CommonLabelText>
                    <BrgButton variant={ButtonVariant.Hollow} onClick={openModal} fullWidth>
                        {t('project_edit.select_reproductions')}
                    </BrgButton>
                </ColumnLabelGroup>
            )}
            <ReproductionList ignoreUserId cardsIds={value} onDelete={onUpdateReproductionGoods} onEdit={openModal} />
            <ColumnLabelGroup >
                <CommonLabelText>
                    {t('tariffs.book_price')}
                </CommonLabelText>
                <QueuePriceText>
                    {activeTariff?.userPrice || '0'} <FlorinIcon size={20 / 16} mobileSize={20 / 16} margin="0" />
                </QueuePriceText>
            </ColumnLabelGroup>
        </ProjectEditPageGridRowBase>

    )
};

export default BookReproductionsField;